import {
  AgencyMetricsQuery,
  useAgencyMetricsQuery,
} from 'core/graphql/Statistics/ItineraryStatistics.generated';

type AgencyStatisticsResult = {
  couriers: AgencyMetricsQuery;
  loadingStatistics: boolean;
  refresh: () => Promise<void>;
};

const useAgencyStatisticsDataStore = (
  agencyId: string | null,
  date: string | null,
  courierIds: number[] | null,
): AgencyStatisticsResult => {
  const { loading, data, refetch } = useAgencyMetricsQuery({
    skip: !agencyId || !date || !courierIds || courierIds.length === 0,
    variables: {
      agencyId: agencyId || '',
      date: date || undefined,
      where: courierIds
        ? {
            courierId: {
              in: courierIds,
            },
          }
        : undefined,
    },
  });

  const refresh = async () => {
    await refetch({
      agencyId: agencyId || '',
      date: date || undefined,
      where: courierIds
        ? {
            courierId: {
              in: courierIds,
            },
          }
        : undefined,
    });
  };

  if (data) {
    return {
      couriers: data,
      loadingStatistics: loading,
      refresh,
    };
  }

  return {
    couriers: {
      CouriersByAgency: [],
    },
    loadingStatistics: loading,
    refresh,
  };
};

export default useAgencyStatisticsDataStore;
